<template>
   <div class="wrapper">
       <div class="header">
           <div class="title">个人中心</div>
           <div class="head-img">
               <img :src="userInfo.headimgurl" alt="">
           </div>
           <div class="user-name">{{userInfo.nickname}}</div>
           <div v-if="userInfo.member_level > 0" class="user-name">会员等级：{{userInfo.member_name}}</div>
           <div v-if="userInfo.member_level > 0" class="user-name">到期时间：{{userInfo.member_time_str}}</div>
       </div>

        <div class="content my-content">
            <div class="price-box">
                <div class="price-item">
<!--                    <p class="price">{{userInfo.balance}}</p>-->
<!--                    <p>会员卡总余额（元）</p>-->
                    <p class="price">{{userInfo.red_balance}}</p>
                    <p>红包数量（个）</p>
                </div>
                <div class="price-item">

                    <p class="price">{{userInfo.shop_scan_balance}}</p>
                    <p>扫码充值活动余额</p>
                </div>
				
				<div class="price-item" style="margin-top: 10px;">
				    <p class="price"><van-button round color="#00BFFF" size="mini" @click="goPage(1)">去抽奖</van-button></p>
				</div>
				<div class="price-item" style="margin-top: 10px;">
				    <p class="price"><van-button round color="#FFB833" size="mini" @click="goPage(2)">去兑换</van-button></p>
				</div>
            </div>
            <div class="option">
                <van-grid :border="false" :column-num="3">
					<van-grid-item  text="实体消费记录" icon="https://www.shoudaole.cn/uploads/default/icon/xiaofei.png" to="userConsumeList" />
                    <van-grid-item  text="红包获取记录"  icon="cash-on-deliver" to="userredlist"/>
                    <van-grid-item  text="红包消费记录"  icon="cash-back-record" to="userreduselist"/>
					
					<van-grid-item  text="兑换/购买商品"  icon="https://www.shoudaole.cn/uploads/default/icon/orders.png" to="orderList"/>
					<!-- <van-grid-item  text="商家商品订单" icon="https://www.shoudaole.cn/uploads/default/icon/shangjia.png" to="shopgoodsorder"/> -->
					<van-grid-item  text="商家服务兑换" icon="https://www.shoudaole.cn/uploads/default/icon/goods.png" to="newshopgoodsorder"/>
					<van-grid-item  text="成为代理" icon="https://www.shoudaole.cn/uploads/default/icon/cwdl.png" to="dl/register" />
					<van-grid-item  text="我的邀请码" icon="https://www.shoudaole.cn/uploads/default/icon/yqm.png" @click="showQrcode()" />
					<van-grid-item  text="代理提成记录" icon="https://www.shoudaole.cn/uploads/default/icon/dls.png" to="dl/tclist" />
					<van-grid-item  text="下级代理" icon="https://www.shoudaole.cn/uploads/default/icon/tc.png" to="dl/dlusers" />
					
					<van-grid-item  text="提现记录"  icon="https://www.shoudaole.cn/uploads/default/icon/dingdan.png" to="userTXList"/>
                    <van-grid-item  text="红包转增"  icon="https://www.shoudaole.cn/uploads/default/icon/hongbao.png" to="Hbtouser"/>
					<van-grid-item  text="会员卡"  icon="idcard" to="cardList"/>
					
					
                    <!-- <van-grid-item  text="分享专区"  icon="records" @click="goshareuser" /> -->
                    <!-- <van-grid-item  text="我的待领红包"  icon="cash-back-record" to="userWaitingList"/> -->
                    <van-grid-item  text="我的收货地址"  icon="location" to="addressList"/>
					<van-grid-item  text="分享有益"  icon="records" to="shareuser"/>
<!--                    <van-grid-item  text="修改提现密码"  icon="closed-eye" @click="handleGoRetrievePayPass"/>-->
                    <van-grid-item  text="修改登录密码"  icon="closed-eye" to="userRetrievePass"/>
					<van-grid-item  text="退款申请" icon="https://www.shoudaole.cn/uploads/default/icon/refund.png" to="refund" />
                    <van-grid-item  text="退出登录"  icon="exchange" @click="getOut"/>

                </van-grid>
<!--                <van-cell title="签到" icon="records" is-link to="userSignIn"/>-->
<!--                <van-cell title="我的订单" icon="orders-o" is-link to="orderList"/>-->
<!--                <van-cell title="我的代金券" icon="orders-o" is-link to="cashCoupon"/>-->
<!--                <van-cell title="会员卡" icon="idcard" is-link to="userCardList"/>-->
<!--                <van-cell title="线下兑换记录" icon="orders-o" is-link to="userExchangeList"/>-->
<!--                <van-cell title="我的消费" icon="cash-on-deliver" is-link to="userConsumeList" />-->
<!--                <van-cell title="我的待领红包" icon="cash-back-record" is-link to="userWaitingList" />-->
<!--                <van-cell title="我的收货地址" icon="location" is-link @click="handleGoAddressList"/>-->
<!--                <van-cell title="提现记录" icon="cash-back-record" is-link to="userTXList" />-->
<!--                <van-cell title="修改提现密码" icon="closed-eye" is-link @click="handleGoRetrievePayPass" />-->
<!--                <van-cell title="修改登录密码" icon="closed-eye" is-link to="userRetrievePass" />-->
<!--                <van-cell title="退出登录" icon="exchange" @click="getOut" is-link/>-->
			</div>
			<div class="xy-box">
				<!-- <a href="https://www.shoudaole.cn/dist/#/shareuser">分享</a>
				| -->
				<a href="https://www.shoudaole.cn/dist/#/fuwuxieyi">服务协议</a>
				|
				<a href="https://www.shoudaole.cn/dist/#/yinsizhengce">隐私政策</a>
			</div>
        </div>

       <div class="footer">
           <TheFooterBar :active="5"/>
       </div>
   </div>
</template>

<script>
    import {mapState,mapActions} from 'vuex'
    import {getUserInfoService,getOutService} from "../service/userService";
    import {Toast,Dialog} from 'vant';
    import TheFooterBar from "../components/base/TheFooterBar";

    import Cookies from 'js-cookie';
	//import {wecharShare} from "../util/weChat.js";


    export default {
        name : 'my',//个人中心
        data () {
            return {
                userInfo:{},
            }
        },
        mounted () {
            sessionStorage.removeItem('changeAddress');
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
        },
        methods : {
            ...mapActions(['setOpenID']),
			goshareuser(){
				window.location.href="https://www.shoudaole.cn/dist/#/shareuser?times="+Date.parse(new Date());
					// this.$router.push({
			  //           name:'shareuser'
			  //       })
			},
			showQrcode(){
				var dl = this.userInfo.dl;
				if(!dl){
					Toast('您还不是代理哦');
				}
				if(dl.level < 1){
					Toast('您还不是代理哦');
				}
				Dialog.confirm({
					title: '我的邀请码',
					message: dl.code
				}).then(() => {
					
				}).catch(() => {
					
				});
			},
			goPage(page){
				if(page == 1){
					window.location.href = "https://www.shoudaole.cn/dist/#/luck";
				} else if(page == 2) {
					this.$router.push({
						name: 'goodsMuster',
						params: {
							typeId: 0,
							searchKey: '-1'
						}
					});
				}
			},
            getUserInfo(){
                if(!this.userId){
                    Toast('用户信息读取失败，请刷新');
                    return;
                }
                getUserInfoService(this.userId).then(res => {
                    if(res.status === 1){
                        // if(res.datas.openid && res.datas.openid !== Cookies.get('o_id')){
                        //     Dialog.alert({
                        //         title:'提示',
                        //         message:'您的账号在其他地方登录，请重新登录'
                        //     }).then(() => {
                        //         this.$router.push({
                        //             name:'userLogin'
                        //         })
                        //     })
                        // }else if(res.datas.openid){
                        //     this.userInfo = res.datas;
                        // }else{
                        //     this.$router.push({
                        //         name:'userLogin'
                        //     })
                        // }
                        if(res.datas.openid){
                            this.userInfo = res.datas;
                        }else{
                            this.$router.push({
                                name:'userLogin'
                            })
                        }
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err)
                })
            },

            //刷新
            handleRefresh(){
                this.$router.go(0);
            },

            //修改提现密码
            handleGoRetrievePayPass(){
                this.$router.push({
                    name:'userRetrievePayPass',
                    params:{
                        balance:-1,
                    }
                })
            },

            //查看我的订单
            handleGoAddressList(){
                sessionStorage.removeItem('s_s');
                this.$router.push({
                    name:'userAddressList',
                    params:{
                        addressId:0,
                    }
                })
            },

            //退出登录
            getOut(){
                Dialog.confirm({
                    confirmButtonColor:'#00BFFF',
                    title: '提示',
                    message: '确定退出吗'
                }).then(() => {
                    getOutService(this.userId).then(res => {
                        Cookies.remove('o_tel');
                        // Cookies.remove('o_id');
                        this.setOpenID('');
                        if(res.status === 1){
                            this.$router.push({
                                name:'userLogin'
                            })
                        }
                    })
                }).catch(() => {
                    // on cancel
                });

            },

        },
        components : {
            TheFooterBar
        },
        beforeRouteEnter(to,from,next){
            next(vm => {
				console.log(vm.userId);
                if(!vm.userId){
                    Dialog.confirm({
                        confirmButtonColor:'#00BFFF',
                        title: '提示',
                        message: '您还未登录，是否前去登录'
                    }).then(() => {
                        vm.$router.push({
                            name:'userLogin',
                        })
                    }).catch(() => {
                        vm.$router.go(-1);
                    });
                }else{
                    vm.getUserInfo();
                }
            })
        },
        computed:{
            ...mapState({
                userId: state => state.userInfo.userId,
                openid: state => state.userInfo.openId,
            })
        }
     }
</script>

<style scoped lang='scss'>
    .wrapper{
        overflow-y: scroll;
        .header{
            /* background-image: url("../assets/img/icon/mybg.png"); */
			background-image: linear-gradient(to left,#00BFFF, #A9F0F8);/* 自右向左 */;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 30px 0;
            .title{
                /* color: #444444; */
				color: #fff;
                font-size: 14px;
                font-weight: bold;
            }
            .head-img{
                width: 80px;
                height: 80px;
                margin: 10px 0;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
            .user-name{
                color: #fff;
            }
        }
        .content{
            background-color: #FDFBFB;
            padding-bottom: 60px;
            position: relative;
            .price-box{
                position: absolute;
                z-index: 99;
                padding: 20px;
                width: 300px;
                box-sizing: border-box;
                right: 50%;
                margin-right: -160px;
                top: -20px;
                background: #ffffff;
                display: flex;
				flex-wrap: wrap;
                box-shadow:0px 3px 17px 1px rgba(203,201,197,0.23);
                border-radius: 10px;
                .price-item{
					width: 50%;
                    /* flex: 1; */
                    text-align: center;
                    &:nth-child(1){
                        // border-right: 1px solid #B9B9B9;
                    }
                    p{
                        color: #333333;
                    }
                    .price{
                        font-size: 18px;
                        color: #FFB833;
                    }
                }
            }
            .option{
                padding-top: 100px;
            }
        }
        .icon{
            width: 24px;
            height: 24px;
        }
		.xy-box{
			margin-top:30px;
			text-align: center;
			width: 100%;
			color: #5599FF;
			height: 30px;
			line-height: 30px;
		}
		.xy-box a{
			color:#5599FF;
		}
    }
</style>
<style>
    .my-content .van-icon-records{
        color: rgb(242,154,39);
    }
    .my-content .van-cell{
        background-color: #FDFBFB;
        color: #444444;
    }
    .my-content .van-icon-idcard{
        color: rgb(117,64,230);
    }
    .my-content .van-icon-balance-o{
        color: rgb(117,64,230);
    }
    .my-content .van-icon-orders-o{
        color: rgb(208,45,96);
    }
    .my-content .van-icon-balance-pay{
        color: rgb(54,95,245);
    }
    .my-content .van-icon-cash-on-deliver{
        color: rgb(242,154,39);
    }
    .my-content .van-icon-location{
        color: rgb(117,64,230);
    }
    .my-content .van-icon-closed-eye{
        color: rgb(208,45,96);
    }
    .my-content .van-icon-exchange{
        color: rgb(117,64,230);
    }
    .my-content .van-icon-cash-back-record{
        color: rgb(208,45,96);
    }
</style>